import {
    deleteFoldersFromFolderTable,
    getAllSubFolderIds,
    moveFolderToParentFolder,
    removeFolderFromParentFolder,
} from 'owa-folders';
import { actionNames, DeleteFolderAction } from 'owa-mail-store-actions';
import deleteFolderService from 'owa-mail-store/lib/services/deleteFolderService';
import { FolderStore, Folder } from 'owa-folders';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';

export default action('deleteFolder')(async function deleteFolder(
    folders: FolderStore,
    folderId: string,
    softDelete: boolean,
    deletedItemsFolderId: string
) {
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    const folderToDelete: Folder = folders.folderTable.get(folderId);

    undoActions.clearLastUndoableAction();

    removeFolderFromParentFolder(folders, folderToDelete);

    const folderIdsToDelete = getAllSubFolderIds(folderToDelete.FolderId.Id);

    // raise the stitch to notify list view component to update the list view store
    raiseAction<DeleteFolderAction>(actionNames.DeleteFolderAction)(folderIdsToDelete);

    // In case of soft delete, remove the folder from the foldertable otherwise we move the fodler to the deleted items folder of corresponding mailbox
    if (softDelete) {
        deleteFoldersFromFolderTable(folders, folderIdsToDelete);
    } else {
        moveFolderToParentFolder(folders, folderToDelete, deletedItemsFolderId);
    }

    // TODO: VSO 11909: Handle undo for destructive mail actions
    await deleteFolderService(folderId, softDelete);
});
